import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
import './Footer.css';

const Footer = () => {
  const [footerRef, footerVisible] = useScrollAnimation(0.1);
  const navigate = useNavigate();

  // Function to handle service link clicks
  const handleServiceClick = (e, serviceType) => {
    e.preventDefault();
    
    const serviceMapping = {
      'website-development': 'website-development',
      'mobile-applications': 'mobile-applications',
      'software-solutions': 'software-solutions',
      'unity-gaming': 'unity-gaming'
    };
    
    const categoryParam = serviceMapping[serviceType];
    if (categoryParam) {
      navigate(`/projects?category=${categoryParam}`);
    } else {
      navigate('/projects');
    }
  };

  return (
    <footer ref={footerRef} className={`footer ${footerVisible ? 'animate' : ''}`}>
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>GoToBusiness</h3>
            <p>
              Your trusted partner for digital transformation. We create innovative 
              websites, applications, software solutions, and Unity games that drive 
              business growth and success.
            </p>
            <div className="social-links">
              <a href="#" className="social-link facebook" aria-label="Facebook">
                <i className="fab fa-facebook-f"></i>
              </a>
              <a href="https://www.instagram.com/_rohit_gupta73?igsh=MW9vcDBvZzFjdXV4Ng%3D%3D" target="_blank" rel="noopener noreferrer" className="social-link instagram" aria-label="Instagram">
                <i className="fab fa-instagram"></i>
              </a>
              <a href="https://www.linkedin.com/in/rohit-gupta2017/" target="_blank" rel="noopener noreferrer" className="social-link linkedin" aria-label="LinkedIn">
                <i className="fab fa-linkedin-in"></i>
              </a>
            </div>
          </div>
          
          <div className="footer-section">
            <h4>Our Services</h4>
            <ul>
              <li><a href="#" onClick={(e) => handleServiceClick(e, 'website-development')}>Website Development</a></li>
              <li><a href="#" onClick={(e) => handleServiceClick(e, 'mobile-applications')}>Mobile Applications</a></li>
              <li><a href="#" onClick={(e) => handleServiceClick(e, 'software-solutions')}>Software Solutions</a></li>
              <li><a href="#" onClick={(e) => handleServiceClick(e, 'unity-gaming')}>Unity Gaming</a></li>
              <li><a href="#" onClick={(e) => handleServiceClick(e, 'other')}>E-commerce Platforms</a></li>
              <li><a href="#" onClick={(e) => handleServiceClick(e, 'other')}>Digital Consulting</a></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/projects">Portfolio</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/rent">Rent</Link></li>
              <li><Link to="/contact">Contact Us</Link></li>
              <li><a href="#portfolio">Portfolio</a></li>
              <li><a href="#testimonials">Testimonials</a></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>Get In Touch</h4>
            <div className="contact-info">
              <p>📧 rohitgupta17503@gmail.com</p>
              <p>📞 +91 8650960313</p>
              <p>📍 Flat UG10 Best Homes6<br />Gali no 4 Sector 73 sarfabad<br />Noida, Gautam Buddha Nagar 201301</p>
              <p>🕒 Mon - Fri: 9:00 AM - 6:00 PM<br />Saturday: 10:00 AM - 4:00 PM</p>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; 2025 GoToBusiness. All rights reserved. Crafted with ❤️ for digital excellence.</p>
          <div className="footer-links">
            <a href="#privacy">Privacy Policy</a>
            <a href="#terms">Terms of Service</a>
            <a href="#cookies">Cookie Policy</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;